import { CSSProperties, memo } from "react";
import {
  checkTimezoneDiffFromSystem,
  GetTime,
  getTimeZoneAbbreviation,
} from "@markit/common.utils";
import { Colors } from "../../utils/colors";

type LocalSystemDateDisplayProps = {
  timestamp: string;
  timezone: string;
  textStyles?: CSSProperties;
};

// When we want to determine whether to display the local and system date together
// Displays if the local timezone is different from the system timezone
const LocalSystemDateDisplay = memo(function LocalSystemDateDisplayFn(
  props: LocalSystemDateDisplayProps
) {
  const { timestamp, timezone, textStyles } = props;

  return (
    <>
      {checkTimezoneDiffFromSystem(timezone) ? (
        <span>
          <span> • </span>
          <span style={{ color: Colors.ORANGE1, ...textStyles }}>
            {GetTime(timestamp, timezone)} {getTimeZoneAbbreviation(timezone)}
          </span>
        </span>
      ) : null}
    </>
  );
});

export default LocalSystemDateDisplay;
